import AmexGDAB2BTestimonialsCard from './AmexGDAB2BTestimonialsCard';

export default AmexGDAB2BTestimonialsCard;
